module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="applications-container">\n    <mapbs-applicationlink\n        ng-repeat="item in ctrl.applicationList"\n        mapbs-applicationlink-title="item.title"\n        mapbs-applicationlink-description="item.description"\n        mapbs-applicationlink-url="item.url"\n        mapbs-applicationlink-active="ctrl.activeLink === item.name"\n        mapbs-applicationlink-mobile="ctrl.mobile"\n    >\n    </mapbs-applicationlink>\n</div>\n';

}
return __p
}